// JOBE-0167.5: DecayRow — single row in the Decay tab.

import { Spark } from '../../components/Spark/Spark.jsx';

/**
 * @param {object} props
 * @param {object} props.memory  — { urn, body_snippet, decay: { curve, threshold, eta_days } }
 */
export function DecayRow({ memory }) {
  const d = memory.decay || {};
  return (
    <li className="decay-row" data-testid="decay-row" data-urn={memory.urn}>
      <div className="decay-row__col decay-row__col--text">
        <div className="decay-row__urn">{memory.urn}</div>
        {memory.body_snippet && (
          <div className="decay-row__snippet">"{memory.body_snippet}"</div>
        )}
      </div>
      <div className="decay-row__col decay-row__col--chart" data-testid="decay-row-chart">
        {Array.isArray(d.curve) && d.curve.length > 0 ? (
          <Spark
            data={d.curve}
            mode="absolute"
            tone="ink"
            target={d.threshold}
            ariaLabel={`Decay curve for ${memory.urn}`}
          />
        ) : (
          <span className="decay-row__no-curve">no curve</span>
        )}
      </div>
      <div className="decay-row__col decay-row__col--eta" data-testid="decay-row-eta">
        {d.eta_days != null ? `decays in ~${d.eta_days} days` : ''}
      </div>
    </li>
  );
}

export default DecayRow;
